import { StyledComponentWithProps } from '@/types/StyledComponentWithProps';
import { Grid, Theme, Paper, PaperProps, styled, Icon } from '@mui/material';
import CommentList from '../Comments/CommentList/CommentList';

function getMobilePadding({
  hasComments,
  theme,
}: {
  hasComments: boolean;
  theme: Theme;
}) {
  if (hasComments) {
    return theme.spacing(5, 5, 2);
  }
  return theme.spacing(5);
}
function getDesktopPadding({
  hasComments,
  theme,
}: {
  hasComments: boolean;
  theme: Theme;
}) {
  if (hasComments) {
    return theme.spacing(8, 8, 5);
  }
  return theme.spacing(8);
}

type PaperPropTypes = PaperProps & {
  hasComments: boolean;
};

export const Wrapper: StyledComponentWithProps<PaperPropTypes> = styled(Paper)`
  background-color: ${({ theme }) => theme.palette.grey[100]};
  padding: ${getMobilePadding};
  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: ${getDesktopPadding};
  }
`;

export const DesktopAvatarWrapper = styled(Grid)`
  display: none;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    display: flex;
  }
`;

export const MobileAvatarWrapper = styled(Grid)`
  display: flex;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    display: none;
  }
`;

export const MessageIcon = styled(Icon)<{
  collapsed: boolean;
}>`
  color: ${({ theme, collapsed }) =>
    collapsed ? theme.palette.primary[500] : theme.palette.text.secondary};
`;

export const CommentSumary = styled('div')``;
